import { Route } from 'react-router-dom';

import { LayoutRender } from './layout/layout-render/layout-render.component';
import { Layout } from './layout/layout.component';
import { Modules } from './modules/modules.component';
import { Slots } from './slots/slots.component';
import { Spots } from './spots/spots.component';

export function ApplicationsSpotsRoutes() {
    return (
        <Route path='spots'>
            <Route path='contents'>
                <Route
                    index
                    element={<Layout />}
                />
                <Route
                    path=':spotId'
                    element={<LayoutRender />}
                />
            </Route>
            <Route
                path='spots'
                element={<Spots />}
            />
            <Route
                path='modules'
                element={<Modules />}
            />
            <Route
                path='slots'
                element={<Slots />}
            />
        </Route>
    );
}
